import React, { useEffect, useRef, useState } from 'react';
import classNames from "classnames";
import ButtonBase from '@material-ui/core/ButtonBase';
import IconsService from "external-services/icons-service/icons.service";
import style from './style.module.css';
import {IBidirectionalStepper, StepperSize, IStepperState} from './types';
import { IconTypes } from 'external-services/icons-service/icons.types';
import { btnIdPrefix } from '../DatePicker';
import { makeStyles } from '@material-ui/core/styles';

const defaultState = {
  left: false,
  right: false,
  mid: false,
};

const $style = (styles: any[]) => {
  return  Object.assign({}, ...styles)
}

const BidirectionalStepper = (props: IBidirectionalStepper) => {

  const {isFloorPlan} = props


  // these are the color changes for FloorPlan
  const useStyles = makeStyles({
    overEffectContainerFP: {
      height: 'calc(100% - 7px) !important',
      backgroundColor: '#333 !important',
      zIndex: -1,
      '&:hover': {
        backgroundColor: '#434343 !important'
      }
    },
    iconContainerFP: {
      height: 'calc(100% - 7px) !important',
      backgroundColor: '#333 !important'
    },
    selectedBackgroundColorFP: {
      backgroundColor: 'transparent !important'
    },
    selectedBorderColorFP: {
      borderColor: '#666 !important',
      '&:hover': {
        borderColor: '#666 !important',
      }
    },
    iconEnableColorFP: {
      color: '#fff !important',
    }
  });

  const classes = useStyles();

  const {
    minWidth = 160,//136,
    stepperSize = StepperSize.small,

    disableState = defaultState,
    selectState = defaultState,

    enableUnFocusForMouseLeave = true,

    handleLeftClick = () => {},
    handleRightClick = () => {},
    handleMiddleClick = () => {},

    handleUnFocus = () => {},

    children,
    parentRef = null,
  } = props;
  const IconLeft = IconsService.getIcon(IconTypes.stepperLeft);
  const IconRight = IconsService.getIcon(IconTypes.stepperRight);

  const wrapperRef: any = useRef(null);

  const [disable, setDisable] = useState<IStepperState>(defaultState);
  const [select, setSelect] = useState<IStepperState>(defaultState);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [])

  useEffect(() => {
    setDisable(disableState);
  }, [disableState])

  useEffect(() => {
    setSelect(selectState);
  }, [selectState])

  const handleClickOutside = (event: any) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      if(!parentRef || !parentRef.current) {
        setUnFocus();
      }else if(parentRef && parentRef.current && !parentRef.current.contains(event.target)) {
        setUnFocus();
      }
    }
  }

  const setUnFocus = () => {
    enableUnFocusForMouseLeave && setSelect({
      ...select,
      left: false,
      right: false,
      mid: false,
    });
    enableUnFocusForMouseLeave && handleUnFocus && handleUnFocus();
  }

  const handleClick = (flag: 'left' | 'mid' | 'right') => {
    if(flag === 'left') {
      setSelect({
        ...select,
        left: true,
        right: false,
        mid: false,
      });
      handleLeftClick();
    } else if(flag === 'right') {
      setSelect({
        ...select,
        left: false,
        right: true,
        mid: false,
      });
      handleRightClick();
    }if(flag === 'mid') {
      setSelect({
        ...select,
        left: false,
        right: false,
        mid: true,
      });
      handleMiddleClick();
    }
  }


  return (
    <div className={style.root}>
      <div
        ref={wrapperRef}
        className={classNames({
          [style.stepperContainer]: true,
          [style.containerSmall]: stepperSize === StepperSize.small,
          [style.containerRegular]: stepperSize === StepperSize.regular,
        })}
      >
        <ButtonBase
          data-testid={btnIdPrefix + 'left'}
          disableRipple
          disabled={disableState.left}
          className={classNames({
            [style.iconLeftBtn ]: true,
            [style.disableState]: disableState.left,
          })}
          onClick={() => handleClick('left')}
        >
          <div className={classNames({
            [style.iconLeftContainer]: true,
            [style.iconContainerSmall]: stepperSize === StepperSize.small,
            [style.iconContainerRegular]: stepperSize === StepperSize.regular,
            [style.iconContainerSelected]: select.left,
            [classes.iconContainerFP]: isFloorPlan,
            [classes.selectedBorderColorFP]: isFloorPlan,
          })}>
            <IconLeft className={classNames({
              [style.iconSizeSmall]: stepperSize === StepperSize.small,
              [style.iconSizeRegular]: stepperSize === StepperSize.regular,
              [style.iconEnableColor]: !disable.left,
              [style.iconDisableColor]: disable.left,
              [classes.iconEnableColorFP]: isFloorPlan && !disable.left,
            })} />
          </div>
        </ButtonBase>
        <div
          className={classNames({
            [style.midContainer]: true,
            [style.disableState]: disableState.mid,
          })}
          style={$style([
            {
              minWidth: minWidth,
            },
          ])}
        >
          <div
            data-testid={'content-test-id'}
            className={classNames({
              [style.childContainer]: true,
              [style.childContainerFp]: isFloorPlan,
              [style.selectedBackgroundColor]: select.mid,
              [classes.selectedBackgroundColorFP]: select.mid && isFloorPlan,
            })}
            onClick={() => isFloorPlan ? handleClick('mid') : null}
          >
            {children}
          </div>
          <div
            className={classNames({
              [style.overContainer]: true,
            })}
          >
            <button
              data-testid={btnIdPrefix + 'mid'}
              type="button"
              disabled={disableState.mid}
              className={classNames({
                [style.disableState]: disableState.mid,
              })}
              onClick={() => handleClick('mid')}
            >
              <div
                className={classNames({
                  [style.overEffectContainer]: true,
                  [style.selectedBorderColor]: select.mid,
                  [classes.overEffectContainerFP]: isFloorPlan,
                  [classes.selectedBorderColorFP]: isFloorPlan,
                })}
              >
              </div>
            </button>
          </div>

        </div>
        <ButtonBase
          data-testid={btnIdPrefix + 'right'}
          disableRipple
          disabled={disableState.right}
          className={classNames({
            [style.iconRightBtn]: true,
            [style.disableState]: disableState.right,
          })}
          onClick={() => handleClick('right')}
        >
          <div className={classNames({
            [style.iconRightContainer]: true,
            [style.iconContainerSmall]: stepperSize === StepperSize.small,
            [style.iconContainerRegular]: stepperSize === StepperSize.regular,
            [style.iconContainerSelected]: select.right,
            [classes.iconContainerFP]: isFloorPlan,
            [classes.selectedBorderColorFP]: isFloorPlan,
          })}>
            <IconRight className={classNames({
              [style.iconSizeSmall]: stepperSize === StepperSize.small,
              [style.iconSizeRegular]: stepperSize === StepperSize.regular,
              [style.iconEnableColor]: !disable.right,
              [style.iconDisableColor]: disable.right,
              [classes.iconEnableColorFP]: isFloorPlan && !disable.right,
            })} />
          </div>
        </ButtonBase>
      </div>
    </div>
  )
}

export default BidirectionalStepper;
